<template lang='pug'>
.v-delivery-small.basket-small(v-if="delivery")
	.basket-small__widget
		v-svg-icon.basket-small__icon(icon="delivery-small")
		.basket-small__title
			span.basket-small__title-text {{delivery.text}}
			v-svg-icon.basket-small__title-icon(icon="small-chevron")
		.basket-small__dd-wrap
			.basket-small__dd
				v-switchers
</template>

<script>
export default {
	computed: {
		delivery() {
			return this.$store.state.delivery;
		}
	}
};
</script>